/**
 * Chakra outline buttons on dark Stream Player UIs: light hover bg pairs with dark text.
 * Ghost buttons use a *subtle* hover (`whiteAlpha.*`) on near-black — keep labels white there.
 */
export const streamOutlineOnDarkHover = {
  _hover: { bg: 'gray.100', color: 'gray.900', borderColor: 'gray.300' },
  _active: { bg: 'gray.200', color: 'gray.900', borderColor: 'gray.400' },
} as const;

export const streamGhostOnDarkHover = {
  _hover: { bg: 'whiteAlpha.200', color: 'white' },
  _active: { bg: 'whiteAlpha.300', color: 'white' },
} as const;

export const streamRedOutlineOnDarkHover = {
  _hover: { bg: 'red.50', color: 'red.900', borderColor: 'red.400' },
  _active: { bg: 'red.100', color: 'red.900', borderColor: 'red.500' },
} as const;

export const streamPinkOutlineHover = {
  _hover: { bg: 'pink.100', color: 'pink.900', borderColor: 'pink.300' },
  _active: { bg: 'pink.200', color: 'pink.900', borderColor: 'pink.400' },
} as const;

export const streamGhostDangerHover = {
  _hover: { bg: 'red.100', color: 'red.900' },
  _active: { bg: 'red.200', color: 'red.900' },
} as const;

export const streamGhostPinkHover = {
  _hover: { bg: 'pink.100', color: 'pink.900' },
  _active: { bg: 'pink.200', color: 'pink.900' },
} as const;

/** Teal outline (e.g. Resume) — light hover needs dark teal text */
export const streamTealOutlineHover = {
  _hover: { bg: 'teal.50', color: 'teal.900', borderColor: 'teal.500' },
  _active: { bg: 'teal.100', color: 'teal.900', borderColor: 'teal.600' },
} as const;
